import { render } from "./TextualGenreSelect.vue?vue&type=template&id=87ca5480"
import script from "./TextualGenreSelect.vue?vue&type=script&lang=js"
export * from "./TextualGenreSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__